import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { validateOtp, generateOtp } from "../../redux/slice/sendOtp";
// import { fetchCustomerDetails } from "../../redux/slice/customerDetails";
import { fetchCustomerDetails } from "../../redux/slice/checkCustomer";

import "./Otplogin.scss";
import { AppContext } from "../../utils/context";
import Layout from "../../component/layout/Layout";
import Spinner from "../../component/spinner/Spinner";
import {
  getOtpErrorMessage,
  isOtpGenerateSuccess,
} from "../../utils/otpErrors";

function Otplogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mobile } = useContext(AppContext);
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [submitFlag, setSubmitFlag] = useState(false);
  const [resendFlag, setResendFlag] = useState(false);
  const [otpCount, setOtpCount] = useState(60); // Countdown timer in seconds
  const sessionId = localStorage.getItem("sessionId");

  const { validateOptObj, generateOtpObj } = useSelector(
    (state) => state.otpGenerateData
  );
  // const { customerDetailsData } = useSelector((state) => state.customerDetails);

  // Handle OTP input change
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Focus the next input
    if (element.nextSibling && element.value !== "") {
      element.nextSibling.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const obj = {
      mobile,
      sessionId,
      otp: otp.join(""),
    };
    const result = await dispatch(validateOtp(obj));
    setSubmitFlag(true);

    let customerDetailsResult;

    if (result?.payload?.status?.success) {
      customerDetailsResult = await dispatch(fetchCustomerDetails(mobile));
      if (customerDetailsResult?.payload?.statusLabel === "Deletion_Pending") {
        toast.error("Customer is pending for deletion!!");
        localStorage.clear();
        navigate("/login");
      } else {             
        if (
          customerDetailsResult.payload?.errors
        ) {
          navigate("/new-customer");
          setSubmitFlag(false);
        } else if (
          customerDetailsResult.payload?.profiles?.length !== 0
        ) {
          navigate("/home");
          setSubmitFlag(false);
        }
      }
    } else if (!result?.payload?.status?.success) {
      toast.error(result?.payload?.status?.message);
    }
  };
  const handleBackspace = (index, event) => {
    if (event.key === "Backspace") {
      if (index > 0) {
        const prevInput = document.getElementById(`otp${index - 1}`);
        prevInput.focus();
      }
    }
  };

  const handleResendOtp = async () => {
    const sessionId = localStorage.getItem("sessionId");
    const otpInputData = {
      mobile,
      sessionId,
    };
    const otpOutput = await dispatch(generateOtp(otpInputData));

    if (isOtpGenerateSuccess(otpOutput?.payload)) {
      setSubmitFlag(false);
      setResendFlag(false);
      setOtpCount(60);
      setOtp(new Array(4).fill(""));
    } else {
      toast.error(getOtpErrorMessage(otpOutput?.payload));
    }
  };
  // Countdown timer effect
  useEffect(() => {
    if (otpCount > 0) {
      let timer = setInterval(() => {
        setOtpCount((prevCount) => prevCount - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (otpCount === 0) {
      setResendFlag(true);
    }
  }, [otpCount]);
  return (
    <>
      <Layout>
        <div className="mob_h1 ">
          <h1 className="mobile_content ">Welcome to </h1>
          <h1 className="mobile_content ">DLF Malls Rewards</h1>
        </div>
        <div className="otpbox">
          <div className="inner_center_box">
            <div
              className="otp_headtext"
              style={{ display: "flex", justifyContent: "center", gap: "4px" }}
            >
              <span className="desktop_content">Provide</span> OTP sent to{" "}
              <span className="mobilenum">{mobile}</span>
              <span className="changeNum" onClick={() => navigate("/login")}>
                {" "}
                Change
              </span>
            </div>
            <div className="form-check_1">
              <div className="otp_input_container">
                {otp.map((data, index) => (
                  <input
                    className="otp_input"
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    key={index}
                    id={`otp${index}`}
                    value={data}
                    onChange={(e) => handleChange(e.target, index)}
                    onFocus={(e) => e.target.select()}
                    onKeyUp={(e) => handleBackspace(index, e)}
                  />
                ))}
              </div>

              <Link to="/home">
                <button
                  onClick={handleSubmit}
                  // disabled={otpCount > 0}
                  className={
                    otp?.filter(Boolean).length !== 4 ? "disabled_button" : ""
                  }
                  disabled={
                    validateOptObj?.loading || otp?.filter(Boolean).length !== 4
                  }
                >
                  Submit {validateOptObj?.loading ? <Spinner /> : null}
                </button>
              </Link>
              <label className="form-check-label" htmlFor="flexCheckDefault">
                {resendFlag ? (
                  <div>
                    Resend OTP :{" "}
                    <a
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        textDecorationColor: "blue",
                      }}
                      onClick={handleResendOtp}
                    >
                      Resend
                    </a>
                  </div>
                ) : (
                  <div>
                    Resend OTP in:{" "}
                    <span className="timecount"> {otpCount}s</span>
                  </div>
                )}
              </label>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Otplogin;
